import { Ownership } from "./ownership.model";
import { Address } from "../address.model";

export class ProvisioningInfo {

    address = new Address();
    owners = new Array<Ownership>();
  
    public load(data: any): ProvisioningInfo {
  
        Object.assign(this, data);

        this.owners = new Array<Ownership>();

        data.owners
            ?.forEach((o: Ownership) => {
                this.owners?.push(o);
            });

        this.address = new Address();

        if (data.address){
            this.address.load(data.address);
        }

        return this;
    }
  }
  